import {
  IsNotEmpty,
  IsArray,
  ValidateNested,
  IsOptional,
  IsString,
  IsUUID,
  IsInt,
} from 'class-validator';
import { Type } from 'class-transformer';

import { EventListRequestFilters } from '@app/gen/events';

import { BatchEventDto } from './batch-event.dto';

export class SendBatchEventsDto {
  @ValidateNested({ each: true })
  @Type(() => BatchEventDto)
  @IsArray()
  @IsNotEmpty()
  events: BatchEventDto[];

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  tags?: string[];

  @IsUUID()
  @IsString()
  @IsOptional()
  companyId?: string;

  @IsInt()
  @IsOptional()
  totalCount?: number;

  filters?: EventListRequestFilters;
}
